import { useQuery } from "@tanstack/react-query";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/api";

/** Renders nothing when there are no visible testimonials. */
export default function TestimonialsSection() {
  const { data: items = [] } = useQuery({
    queryKey: ["publicTestimonials"],
    queryFn: async () => (await api.get("/testimonials")).data,
    retry: false,
  });
  if (!items || items.length === 0) return null;

  return (
    <section className="bg-gg-bg py-16 sm:py-24" id="testimonials" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.22em] text-gg-brown font-semibold">Kind words</p>
          <h2 className="font-heading text-4xl sm:text-5xl text-[var(--gg-text)] mt-2">From families we've grown with</h2>
        </header>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t) => (
            <article
              key={t.id}
              className="rounded-2xl border border-gg-border bg-gg-surface p-6 sm:p-7 flex flex-col"
              data-testid={`testimonial-${t.id}`}
            >
              <Quote className="text-gg-green/40" size={28} />
              <p className="text-base text-[var(--gg-text)]/90 italic mt-3 flex-1 leading-relaxed">
                "{t.quote}"
              </p>
              <div className="mt-5 flex items-center gap-3 pt-4 border-t border-gg-border">
                {t.photo_url ? (
                  <img src={t.photo_url} alt="" className="w-10 h-10 rounded-full object-cover ring-1 ring-gg-border" />
                ) : (
                  <div className="w-10 h-10 rounded-full bg-gg-green/15 text-gg-green font-heading text-lg flex items-center justify-center">
                    {t.author_name.charAt(0)}
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-sm text-[var(--gg-text)]">{t.author_name}</p>
                  {t.role && <p className="text-xs text-gg-muted">{t.role}</p>}
                </div>
                <div className="flex">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <Star
                      key={n}
                      size={12}
                      className={n <= t.rating ? "fill-[#D9933B] text-[#D9933B]" : "text-gg-border"}
                    />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
